export default __webpack_public_path__ + "static/techcrunch_logo_shadowed-17f158b25ef2d2e7c8c24eab4de0d8b0.png";